module.exports = __webpack_public_path__ + "images/49af7867dd5ba5c66ba2371410bd9bd3.svg";